import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/common/new_window_blue.svg'
import _imports_1 from '@/assets/images/common/arrow_right.svg'


const _withScopeId = n => (_pushScopeId("data-v-03c01a80"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "formTtl" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fontEn" }, "STEP 3"),
  /*#__PURE__*/_createTextVNode("お申込内容の確認")
], -1))
const _hoisted_2 = { class: "common-section" }
const _hoisted_3 = { class: "customer-info" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "formCap" }, "お申込者情報", -1))
const _hoisted_5 = { class: "block" }
const _hoisted_6 = { class: "check-field-group" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "姓", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "名", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "セイ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "メイ", -1))
const _hoisted_11 = { class: "split-line" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "生年月日", -1))
const _hoisted_13 = { class: "split-line" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "性別", -1))
const _hoisted_15 = { class: "split-line" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "郵便番号", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "都道府県", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "市区町村", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "町名・番地", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "ビル・建物名", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "会社名", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "部署名", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "field-group-title" }, "ご連絡先", -1))
const _hoisted_24 = { class: "check-field-group" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "電話番号", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "予備電話番号", -1))
const _hoisted_27 = { class: "check-field-group" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "メールアドレス", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "パスワード", -1))
const _hoisted_30 = { class: "check-field-group" }
const _hoisted_31 = { class: "split-line" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "ANAマイレージ番号", -1))
const _hoisted_33 = {
  key: 0,
  class: "user-info"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "formCap" }, "利用者様の情報", -1))
const _hoisted_35 = { class: "block" }
const _hoisted_36 = { class: "check-field-group" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "姓", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "名", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "セイ", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "メイ", -1))
const _hoisted_41 = {
  key: 1,
  class: "shipment-info"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "formCap" }, "配送先の情報", -1))
const _hoisted_43 = { class: "block" }
const _hoisted_44 = { class: "check-field-group" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "姓", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "名", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "セイ", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "メイ", -1))
const _hoisted_49 = { class: "split-line" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "郵便番号", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "都道府県", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "市区町村", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "町名・番地", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "ビル・建物名", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "会社名", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "部署名", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "電話番号", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "formCap" }, "お支払情報", -1))
const _hoisted_59 = { class: "payment-info" }
const _hoisted_60 = { class: "block" }
const _hoisted_61 = { class: "check-field-group" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "お支払い方法", -1))
const _hoisted_63 = { key: 0 }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "クレジットカード番号", -1))
const _hoisted_65 = { key: 1 }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "セキュリティコード", -1))
const _hoisted_67 = { key: 2 }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "有効期限", -1))
const _hoisted_69 = {
  key: 3,
  class: "split-line"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "領収書の宛名", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "formCap" }, "ご利用プランの確認", -1))
const _hoisted_72 = { class: "block" }
const _hoisted_73 = { class: "check-field-group" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "ご渡航期間", -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "受取方法", -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("dt", null, "返却方法"),
  /*#__PURE__*/_createElementVNode("dd", null, "郵便ポスト返却(無料)")
], -1))
const _hoisted_77 = { class: "split-line" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "キャンペーン", -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "代理店", -1))
const _hoisted_80 = { class: "estimation-result" }
const _hoisted_81 = { class: "result" }
const _hoisted_82 = { class: "result-list" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "product amount" }, "商品内容"),
  /*#__PURE__*/_createElementVNode("div", { class: "price" }, "料金"),
  /*#__PURE__*/_createElementVNode("div", { class: "tax-category" }, "内消費税")
], -1))
const _hoisted_84 = { class: "table-body" }
const _hoisted_85 = { class: "amount" }
const _hoisted_86 = { class: "price" }
const _hoisted_87 = { class: "tax-category" }
const _hoisted_88 = { class: "result-price" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "合計金額：", -1))
const _hoisted_90 = { class: "block in-case-checkbox" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Open in new window"
}, null, -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/privacy",
  target: "_blank",
  class: "text-link"
}, [
  /*#__PURE__*/_createTextVNode(" 個人情報の取り扱いについて "),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "open in new window"
  })
], -1))
const _hoisted_93 = { class: "order-check-out-block" }
const _hoisted_94 = {
  key: 0,
  class: "invalid-message"
}
const _hoisted_95 = {
  key: 1,
  class: "invalid-message"
}
const _hoisted_96 = ["disabled"]
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow-right",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_98 = { class: "back" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_in_case_check_box = _resolveComponent("in-case-check-box")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("dl", _hoisted_6, [
            _createElementVNode("div", null, [
              _hoisted_7,
              _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_name), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_8,
              _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_name2), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_9,
              _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_gnm1), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_10,
              _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_gnm2), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("dd", null, _toDisplayString(_ctx.dateFormat(_ctx.customerInfoData.order_birthday)), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("dd", null, _toDisplayString(_ctx.sexLabel), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_postcode), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_17,
              _createElementVNode("dd", null, _toDisplayString(_ctx.getPrefNameById(_ctx.customerInfoData.order_shire_id)), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_18,
              _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_address1), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_19,
              _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_address2), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_20,
              _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_address3), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_21,
              _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_company), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_22,
              _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_department), 1)
            ])
          ]),
          _hoisted_23,
          _createElementVNode("dl", _hoisted_24, [
            _createElementVNode("div", null, [
              _hoisted_25,
              _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_phone), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_26,
              _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_tel), 1)
            ])
          ]),
          _createElementVNode("dl", _hoisted_27, [
            _createElementVNode("div", null, [
              _hoisted_28,
              _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_email), 1)
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _hoisted_29,
              _createElementVNode("dd", null, _toDisplayString(_ctx.getMuskedString(_ctx.customerInfoData.order_pwd)), 1)
            ], 512), [
              [_vShow, !_ctx.isLoggedIn]
            ])
          ]),
          _withDirectives(_createElementVNode("dl", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_ana_mileage_no), 1)
            ])
          ], 512), [
            [_vShow, _ctx.isAna]
          ])
        ])
      ]),
      (_ctx.hasDifferentUser)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("dl", _hoisted_36, [
                _createElementVNode("div", null, [
                  _hoisted_37,
                  _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_use_name), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_38,
                  _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_use_name2), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_39,
                  _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_use_gnm1), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_40,
                  _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_use_gnm2), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.hasDifferentDestination)
        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
            _hoisted_42,
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("dl", _hoisted_44, [
                _createElementVNode("div", null, [
                  _hoisted_45,
                  _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_send_name), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_46,
                  _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_send_name2), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_47,
                  _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_send_gnm1), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_48,
                  _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_send_gnm2), 1)
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_send_postcode), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_51,
                  _createElementVNode("dd", null, _toDisplayString(_ctx.getPrefNameById(_ctx.customerInfoData.order_send_shire_id)), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_52,
                  _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_send_address1), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_53,
                  _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_send_address2), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_54,
                  _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_send_address3), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_55,
                  _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_send_company), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_56,
                  _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_send_department), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_57,
                  _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_send_phone), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_58,
      _createElementVNode("div", _hoisted_59, [
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("dl", _hoisted_61, [
            _createElementVNode("div", null, [
              _hoisted_62,
              _createElementVNode("dd", null, _toDisplayString(_ctx.getPayMethodName(
                  _ctx.selectPlanData.order_pay_method,
                  _ctx.customerInfoData.shop_type
                )), 1)
            ]),
            (_ctx.selectPlanData.order_pay_method == '3')
              ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                  _hoisted_64,
                  _createElementVNode("dd", null, _toDisplayString(_ctx.getMuskedCardNumber()), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.selectPlanData.order_pay_method == '3')
              ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                  _hoisted_66,
                  _createElementVNode("dd", null, _toDisplayString(_ctx.getMuskedString(_ctx.customerInfoData.cc.security_code)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.selectPlanData.order_pay_method == '3')
              ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                  _hoisted_68,
                  _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.cc.card_expiration_month) + "月" + _toDisplayString(_ctx.customerInfoData.cc.card_expiration_year) + "年 ", 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.selectPlanData.order_pay_method == '3')
              ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                  _hoisted_70,
                  _createElementVNode("dd", null, _toDisplayString(_ctx.customerInfoData.order_receipt_name), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _hoisted_71,
      _createElementVNode("div", _hoisted_72, [
        _createElementVNode("dl", _hoisted_73, [
          _createElementVNode("div", null, [
            _hoisted_74,
            _createElementVNode("dd", null, _toDisplayString(_ctx.dateFormat(_ctx.selectPlanData.order_from_date)) + "〜" + _toDisplayString(_ctx.dateFormat(_ctx.selectPlanData.order_to_date)) + " 合計" + _toDisplayString(_ctx.calculateDays(
                _ctx.selectPlanData.order_from_date,
                _ctx.selectPlanData.order_to_date
              )) + "日 ", 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCountriesList(), (country) => {
            return (_openBlock(), _createElementBlock("div", {
              key: country.key
            }, [
              _createElementVNode("dt", null, "ご利用国" + _toDisplayString(country.key), 1),
              _createElementVNode("dd", null, _toDisplayString(country.countryName), 1)
            ]))
          }), 128)),
          _createElementVNode("div", null, [
            _hoisted_75,
            _createElementVNode("dd", null, _toDisplayString(_ctx.getReceivingMethodNameByCode(_ctx.selectPlanData.order_get_type)), 1)
          ]),
          _hoisted_76,
          _createElementVNode("div", _hoisted_77, [
            _hoisted_78,
            _createElementVNode("dd", null, _toDisplayString(_ctx.selectPlanData.order_camp_code), 1)
          ]),
          _createElementVNode("div", null, [
            _hoisted_79,
            _createElementVNode("dd", null, _toDisplayString(_ctx.selectPlanData.order_shop_code), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_80, [
        _createElementVNode("div", _hoisted_81, [
          _createElementVNode("div", _hoisted_82, [
            _hoisted_83,
            _createElementVNode("dl", _hoisted_84, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.estimationData.detailInfo, (detail) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: detail.pro_name_show,
                  class: "row"
                }, [
                  _createElementVNode("dt", null, _toDisplayString(detail.pro_name_show), 1),
                  _createElementVNode("dd", null, [
                    _createElementVNode("div", _hoisted_85, _toDisplayString(detail.pro_qty_show), 1),
                    _createElementVNode("div", _hoisted_86, _toDisplayString(detail.pro_amount), 1),
                    _createElementVNode("div", _hoisted_87, _toDisplayString(detail.pro_amount_tax), 1)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("dl", _hoisted_88, [
            _createElementVNode("div", null, [
              _hoisted_89,
              _createElementVNode("dd", null, _toDisplayString(_ctx.estimationData.orderInfo.order_grand_total.toLocaleString()) + "円 ", 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_90, [
        _createVNode(_component_in_case_check_box, {
          name: "agree_terms_condition",
          modelValue: _ctx.formStatus.agreeTermsCondition,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formStatus.agreeTermsCondition) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: "/terms",
              target: "_blank",
              class: "text-link"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" レンタル利用規約 "),
                _hoisted_91
              ]),
              _: 1
            }),
            _createTextVNode(" に同意する ")
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_in_case_check_box, {
          name: "agree_privacy_policy",
          modelValue: _ctx.formStatus.agreePrivacyPolicy,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formStatus.agreePrivacyPolicy) = $event))
        }, {
          default: _withCtx(() => [
            _hoisted_92,
            _createTextVNode(" に同意する ")
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_93, [
        (!_ctx.isConditionsChecked)
          ? (_openBlock(), _createElementBlock("p", _hoisted_94, " レンタル利用規約と個人情報の取り扱いについてをご確認のうえ、同意にチェックしてください。 "))
          : (_ctx.formStatus.errorMessage)
            ? (_openBlock(), _createElementBlock("p", _hoisted_95, _toDisplayString(_ctx.formStatus.errorMessage), 1))
            : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: _normalizeClass(["forward", { disabled: !_ctx.isConditionsChecked }]),
          disabled: !_ctx.isConditionsChecked,
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onOrderCheckOut && _ctx.onOrderCheckOut(...args)))
        }, [
          _createTextVNode(" お申し込みを確定する "),
          _hoisted_97
        ], 10, _hoisted_96),
        _createElementVNode("div", _hoisted_98, [
          _createElementVNode("a", {
            class: "text-link",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onBackToCustomerInfo && _ctx.onBackToCustomerInfo(...args)))
          }, " ←申し込み内容を修正する ")
        ])
      ])
    ])
  ], 64))
}